import React, { useCallback, useState } from "react";
import { useAuth } from "../context/AuthContext";
import MySubscriptionCard from "../components/Cards/MySubscriptionCard";
import MyCarItem from "../components/Cards/MyCarItem";
import ManageVehicle from "../components/Modal/ManageVehicle";
import {
  AddVehicleToSSubscription,
  deleteClientSubscription,
  RemoveVehicleTSubscription,
} from "../api/subscriptionApi";
import { deleteVehicle, createVehicle, editVehicle } from "../api/vehicleApi";
import { Bounce, toast } from "react-toastify";
import CreateVehicleModal from "../components/Modal/CreateVehicleModal";
import EmptyAdd from "../components/EmptyAdd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Go = () => {
  const { clientData, refreshClient } = useAuth();
  const { t } = useTranslation();
  const [selectedSubscription, setSelectedSubscription] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [editMyVehicle, setEditMyVehicle] = useState(null);
  const [isShowVehDetails, setisShowVehDetails] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSetVeh = (vehicleData) => {
    setSelectedVehicle(vehicleData); // Set the selected vehicle.
    setisShowVehDetails(true); // Open vehicle details.
  };
  const handleEditVehicle = (vehicleData) => {
    setisShowVehDetails(false);
    setEditMyVehicle(() => vehicleData);
    setIsModalOpen(true);
  };
  const handleRemoveVehicle = useCallback(
    async (vehicleData) => {
      console.log("Remove vehicle:", vehicleData);
      if (window.confirm(t("confirmdeletecar")) === true) {
        try {
          await deleteVehicle(vehicleData); // Call API to  subscription
          toast.success(t("cardeletesucess"), {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        } catch (error) {
          toast.error(`${t("cardeletefail")} ${error.message} `, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        } finally {
          refreshClient(clientData.client_id);
          setisShowVehDetails(false); // Open vehicle details.
        }
      } else {
        return;
      }
    },
    [selectedSubscription]
  );

  const handleRemovefromSub = useCallback(
    async (vehicleData) => {
      console.log(" IA M REMOVE ", vehicleData);
      const payload = {
        client_subscription_id: selectedSubscription.client_subscription_id,
        client_id: clientData.client_id,
        vehicle_id: vehicleData.vehicle_id,
        subscription_id: selectedSubscription.subscription_id,
      };
      if (
        window.confirm(
          `${t("cardeleteconfirm")} ${
            selectedSubscription.subscription_name
          } ${t("package")} ?`
        ) === true
      ) {
        try {
          await RemoveVehicleTSubscription(payload); // Call API to  subscription
          toast.success(t("cardeletesucess"), {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        } catch (error) {
          toast.error(`${t("cardeletefail")} ${error.message} `, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        } finally {
          refreshClient(clientData.client_id);
          setisShowVehDetails(false); // Open vehicle details.
        }
      } else {
        return;
      }
    },
    [selectedSubscription]
  );

  const handleAddtoSub = async (vehicleData) => {
    if (isVehiclehaveSubscription(vehicleData.vehicle_id)) {
      toast.error(t("carexistinsub"), {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      return;
    }
    const payload = {
      client_subscription_id: selectedSubscription.client_subscription_id,
      client_id: clientData.client_id,
      vehicle_id: selectedVehicle.vehicle_id,
      subscription_id: selectedSubscription.subscription_id,
    };
    if (
      window.confirm(
        `${t("addcartosub")} ${selectedSubscription.subscription_name} ${t(
          "package"
        )} ?`
      ) === true
    ) {
      try {
        await AddVehicleToSSubscription(payload); // Call API to  subscription
        toast.success(t("caradded"), {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } catch (error) {
        toast.error(`${t("addtosuberror")} ${error.message} `, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } finally {
        refreshClient(clientData.client_id);
        setisShowVehDetails(false); // Open vehicle details.
      }
    } else {
      return;
    }
  };
  const handleCloseCarManager = () => {
    setSelectedVehicle(null);
    setisShowVehDetails(false);
  };
  const handleCloseCreateVehicle = () => {
    setSelectedVehicle(null);
    setIsModalOpen(false);
    setEditMyVehicle(null);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCreateVehicle = async (newVehicleData) => {
    if (
      window.confirm(
        `${t("proceedin")} ${
          newVehicleData?.vehicle_id ? t("editing") : t("adding")
        }  ?`
      ) === true
    ) {
      try {
        if (newVehicleData?.vehicle_id) {
          await editVehicle(newVehicleData);
        } else {
          await createVehicle(newVehicleData);
        }
      } catch (e) {
        console.log(e);
      } finally {
        refreshClient(clientData.client_id);
        setisShowVehDetails(false); // Open vehicle details.
        setIsModalOpen(false); // Close the modal
        setEditMyVehicle(null);
      }
    } else {
      return;
    }
  };
  const handleUnsubscribe = async (client_subscription_id) => {
    if (window.confirm(t("proceedcancel")) === true) {
      try {
        await deleteClientSubscription(client_subscription_id);
      } catch (e) {
        console.log(e);
      } finally {
        refreshClient(clientData.client_id);
        setisShowVehDetails(false); // Open vehicle details.
        setIsModalOpen(false); // Close the modal
        setEditMyVehicle(null);
      }
    } else {
      return;
    }
  };
  const isVehicleSubscribed = (vehicleId) => {
    return selectedSubscription?.subscribedVehicles?.some(
      (v) => v.vehicle_id === vehicleId
    );
  };
  const isVehiclehaveSubscription = (vehicleId) => {
    return clientData?.clientSubscriptions?.some((subscription) =>
      subscription.subscribedVehicles?.some((v) => v.vehicle_id === vehicleId)
    );
  };

  if(!clientData){
  return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        {t("signin_to_continue")}
      </h2>
      <p className="text-gray-600 mb-6 max-w-md">
        {t("signin_required_message")}
      </p>
      <div className="flex gap-4">
        <a
          href="/login"
          className="px-5 py-2 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors"
        >
          {t("signin")}
        </a>
        <a
          href="/register"
          className="px-5 py-2 rounded-full border border-blue-600 text-blue-600 hover:bg-blue-50 transition-colors"
        >
          {t("register")}
        </a>
      </div>
    </div>
  );
  }
  return (
    <div className="flex flex-col  justify-start min-h-screen pt-6 ">
      <div className="flex flex-col   items-center  justify-center w-full bg-white text-black py-4 border-t-[5px] border-[#FFCC70] rounded-t-lg">
        <div className="w-full rounded-t-full  flex  items-center  justify-center gap-3 ">
          <h1 className="text-black text-2xl  font-bold">{t("mysub")} </h1>
        </div>
        <div className="w-full bg-gray-50  flex flex-col items-center  justify-start gap-3  min-h-[340px] border-t-2 ">
          <div className="w-full max-w-full overflow-x-auto flex flex-nowrap gap-2  p-2 rounded-md justify-around items-center my-2 ">
            {clientData?.clientSubscriptions?.map((subscriptionData) => (
              <button
                key={subscriptionData.client_subscription_id}
                type="button"
                onClick={() => {
                  setSelectedSubscription(() => subscriptionData);
                }}
                className={` bg-white text-black rounded-2xl items-start shadow-lg  ${
                  selectedSubscription?.client_subscription_id ===
                  subscriptionData.client_subscription_id
                    ? "ring-2 ring-orange-400"
                    : ""
                }`}
              >
                <MySubscriptionCard
                  subscription={subscriptionData}
                  onDelete={(client_subscription_id) =>
                    handleUnsubscribe(client_subscription_id)
                  }
                  showDelete={false}
                />
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col w-full text-black py-4  ">
        <div className="w-full rounded-t-full  flex  items-center  justify-center gap-3 ">
   
          <h1 className="text-black text-2xl font-bold">{t("mycars")} </h1>
          <hr></hr>
        </div>
        <div className="w-full flex flex-col items-center  justify-center gap-3  min-h-[340px] border-t-2 pb-20">
          <EmptyAdd
            onAddClick={handleOpenModal}
            placeholderText={t("newcar")}
            color="text-orange-400"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 justify-items-center w-full">
            {clientData?.vehicle?.map((vehicleData) => (
              <MyCarItem
                key={vehicleData.vehicle_id}
                vehicleData={vehicleData}
                onRemove={(vehicleData) => handleRemoveVehicle(vehicleData)}
                isBelongtoSub={isVehicleSubscribed(vehicleData.vehicle_id)}
                setVehicle={handleSetVeh}
              />
            ))}
          </div>
        </div>
        <ManageVehicle
          isOpen={isShowVehDetails}
          onClose={handleCloseCarManager}
          onEdit={(vehicleData) => handleEditVehicle(vehicleData)}
          onRemove={(vehicleData) => handleRemoveVehicle(vehicleData)}
          vehicleData={selectedVehicle}
          selectedSubscription={selectedSubscription}
          isBelongtoSub={isVehicleSubscribed(selectedVehicle?.vehicle_id)}
          removeSub={(vehicleData) => handleRemovefromSub(vehicleData)}
          addToSub={(vehicleData) => handleAddtoSub(vehicleData)}
        />

        {isModalOpen && (
          <CreateVehicleModal
            onClose={handleCloseCreateVehicle}
            onSubmit={handleCreateVehicle}
            clientId={clientData.client_id}
            editVehicle={editMyVehicle}
          />
        )}
      </div>
    </div>
  );
};

export default Go;
